/* eslint-disable jsx-a11y/anchor-is-valid */
import { Bar } from 'react-chartjs-2';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import ChartDataLabels from 'chartjs-plugin-datalabels';

export function Dashboard3(props: any) {
    const { dataSource } = props
    const data: any = {
        labels: dataSource.labels,
        datasets: [
            {
                datalabels: {
                    anchor: 'center',
                    color: 'white'
                },
                type: "bar",
                label: dataSource.datasets ? dataSource.datasets[0].label : '',
                data: dataSource.datasets ? dataSource.datasets[0].data : [],
                backgroundColor: [
                    '#7A77FF'
                ],
                borderWidth: 1,
            },
            {
                datalabels: {
                    anchor: 'end',
                    color: 'black',
                    align: 'top'
                },
                type: "line",
                label: dataSource.datasets.length > 1 ? dataSource.datasets[1].label : '',
                data: dataSource.datasets.length > 1 ? dataSource.datasets[1].data : [],
                backgroundColor: [
                    '#EB3C4B'
                ],
                borderWidth: 1,
            },
        ],
    }

    const options: any = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
                text: "จำนวนผู้ใช้และจำนวนข้อความ",
                font: {
                    size: 16
                }
            },
            legend: {
                display: false,
            },
            datalabels: {
                anchor: 'center',
                color: 'black',
                labels: {
                    title: {
                        font: {
                            weight: 'bold'
                        }
                    },
                    value: {
                        color: 'green'
                    }
                }
            }
        },
    };

    return (<Bar data={data} plugins={[ChartDataLabels]} options={options} />)

}